import React from "react";
import log from "cslog";

import { ResponsiveLine } from "@nivo/line";
import { startCase } from "lodash";
// import { getTableContent } from "../../../../../dynamicdata/parser";
import { getTableContent } from "../../../../junctionAbs";
import { mobile, parseStyle, tablet } from "../../../../juntion";

function parseLCData(table, gd) {
    if (!Array.isArray(gd.lines) || !Array.isArray(table)) {
        return [];
    }
    return gd.lines.map((line) => ({
        id: startCase(line.column),
        color: "red",
        data: table.map((row) => ({ x: row[gd.xAxis], y: row[line.column] })),
    }));
}

function LineChart({ id, db, device, gs, dydb, ctx }) {
    const data = db[id];

    const ps = parseStyle(data, gs, data.cstate);

    let input = ps.input;
    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    const graphData = getTableContent(dydb, input.graphData);
    log.d(graphData, "GraphData in LC");

    const lc_data = parseLCData(graphData, input.graphData);
    log.d(lc_data, "LC Data");

    return (
        <div
            style={{
                height: input.height || 200,
                width: "100%",
            }}
        >
            <ResponsiveLine
                // data={pie_data}
                data={lc_data}
                margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
                xScale={{ type: "point" }}
                yScale={{
                    type: "linear",
                    min: "auto",
                    max: "auto",
                    stacked: true,
                    reverse: false,
                }}
                enableGridX={false}
                enableGridY={false}
                yFormat=" >-.2f"
                axisTop={null}
                axisRight={null}
                axisBottom={{
                    orient: "bottom",
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: -45,
                    legend: "transportation",
                    legendOffset: 36,
                    legendPosition: "middle",
                    color: "blue",
                }}
                axisLeft={{
                    orient: "left",
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: "count",
                    legendOffset: -40,
                    legendPosition: "middle",
                }}
                colors={{ scheme: "set1" }}
                // pointSize={10}
                pointColor={{ theme: "background" }}
                pointBorderWidth={2}
                pointBorderColor={{ from: "serieColor" }}
                pointLabelYOffset={-12}
                useMesh={true}
                legends={[
                    {
                        anchor: "bottom-right",
                        direction: "column",
                        justify: false,
                        translateX: 100,
                        translateY: 0,
                        itemsSpacing: 0,
                        itemDirection: "left-to-right",
                        itemWidth: 80,
                        itemHeight: 20,
                        itemOpacity: 0.75,
                        symbolSize: 12,
                        symbolShape: "circle",
                        symbolBorderColor: "rgba(0, 0, 0, .5)",
                        effects: [
                            {
                                on: "hover",
                                style: {
                                    itemBackground: "rgba(0, 0, 0, .03)",
                                    itemOpacity: 1,
                                },
                            },
                        ],
                    },
                ]}
            />
        </div>
    );
}

export default LineChart;
